import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Fg6interface } from 'src/app/project/project-settings/shared/data-end-channel-settings-dialog/interfaces/fg6interface';
import { getVerkehrsstufeSelect, getVerkehrsstufeString } from 'src/app/project/shared/enums/verkehrsstufe';
import { getVerkehrszustandSelect, getVerkehrszustandString } from 'src/app/project/shared/enums/verkehrszustand';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { ScenarioControlObject } from 'src/app/project/shared/interfaces/scenario-control-obj';
import { ProjectImageData } from 'src/app/project/shared/interfaces/project-image-data.interface';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { ManualControlService } from 'src/app/project/shared/services/manual-control.service';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { environment } from 'src/environments/environment';
import { DataEndChannelTypeEnum } from 'src/app/project/shared/enums/data-end-channel-type.enum';
import { BarrierPositioningCommand, getPositioningCmdString } from 'src/app/project/shared/enums/barrier-positioning-command.enum';
import { getRadarTypeName } from 'src/app/project/shared/functions/channel-label';

@Component({
  selector: 'avs-project-scenario-route-station-modul',
  templateUrl: './project-scenario-route-station-modul.component.html',
  styleUrls: ['./project-scenario-route-station-modul.component.css']
})
export class ProjectScenarioRouteStationModulComponent implements OnInit, OnDestroy {
  public routeStation?: ProjectRouteStationWithParam | undefined;
  public fg?: number;
  public de?: number;
  public localbusaddress?: number;
  public readonly DeType = DataEndChannelTypeEnum;
  public tlS_Time: number = 0;
  public highPriority: boolean = false;

  public senarioControlId?: number;

  public isVerkehrszustandDropdownOpen: boolean = false;
  public verkehrszustandSelect: SelectInput[] = getVerkehrszustandSelect();
  public selectedVerkehrszustand: SelectInput = { name: "Verkehrssituation " };


  public isTrafficDropdownOpen: boolean = false;
  public trafficSelect: SelectInput[] = getVerkehrsstufeSelect();
  public selectedTraffic: SelectInput = { name: "freier Verkehr", id: 1 };

  public isFunctionDropdownOpen: boolean = false;
  public functionSelect: SelectInput[] = [{ name: 'Aus', id: 0 }, { name: 'An', id: 1 }, { name: 'Blinkend', id: 2 }];
  public selectedFunction: SelectInput = { name: "Funktion" };

  public isPWFunctionDropdownOpen: boolean = false;
  public PWFunctionSelect: SelectInput[] = [{ name: 'Aus', id: 0 }, { name: 'An', id: 1 }];
  public selectedPWFunction: SelectInput = { name: "Funktion" };

  public isBarrierCommandDropdownOpen: boolean = false;
  public barrierCommandSelect: SelectInput[] = [
    { name: getPositioningCmdString(BarrierPositioningCommand.Nullstellung), id: BarrierPositioningCommand.Nullstellung },
    { name: getPositioningCmdString(BarrierPositioningCommand.Sperrstellung), id: BarrierPositioningCommand.Sperrstellung },
    { name: getPositioningCmdString(BarrierPositioningCommand.Schrankenantrieb_abgestellt), id: BarrierPositioningCommand.Schrankenantrieb_abgestellt }
  ];
  public selectedBarrierCommand: SelectInput = { name: "Befehl" };


  public allImages: ProjectImageData[] = [];
  public images: ProjectImageData[] = [];
  public imagesPW: ProjectImageData[] = [];
  public selectedImage?: ProjectImageData;
  public preSelectedImage?: ProjectImageData;
  public isImageSelected = false;
  public fg06settings: any;
  public fg06engineParameter: any;
  DOstate: boolean = false;
  DIstate: boolean = false;



  /*   public EngineParameter: Fg6interface = {
      JamState: false,
      V60State: false,
      V80State: false,
      FreeState: false,
      V100State: false,
      V120State: false,
      DangerState: false
    };
   */

  public imageIntervalCollection: any[] = [];
  protected readonly environment = environment;
  constructor(public dialogRef: MatDialogRef<ProjectScenarioRouteStationModulComponent>,
    private projectService: ProjectService,
    private manualControlService: ManualControlService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.fg = data.kanal.fg;
    this.de = data.kanal.de;
    this.localbusaddress = data.kanal.localbusAddress;
    this.routeStation = data.routeStation;
  }

  /** Sensortyp eines RADAR-Kanals via Radar-Verknüpfung (Fallback „Sensor"). */
  public radarName(kanal: DataEndChannel): string {
    return getRadarTypeName(kanal, this.routeStation?.schemaInfo?.radars) ?? 'Sensor';
  }

  public ngOnInit(): void {
    this.fg06settings = this.data.kanal.fG06_Settings ? JSON.parse(this.data.kanal.fG06_Settings) : null; /* FALSCH! Muss auf die settings von dem scenario zugreifen und nicht auf die so gesetzten engine params */
    if (this.data.kanal.scenarioControlObj && this.data.scenarioManual) {
      this.data.kanal.scenarioControlObj[0].scenarioControl = this.data.scenarioManual.scenarioControl
      this.data.kanal.scenarioControlObj[0].scenarioId = this.data.scenarioManual.scenarioId
      let manualControlSettings = this.data.kanal.scenarioControlObj
      let settings = manualControlSettings.find((x: ScenarioControlObject) => x.scenarioId === this.data.scenarioId)
      let parsedSettings = JSON.parse(settings.scenarioControl.settings)
      if (this.data.kanal.scenarioControlObj[0].scenarioControl) { this.highPriority = this.data.kanal.scenarioControlObj[0].scenarioControl.highPriority }
      if (this.data.routeStation !== undefined) { if (parsedSettings) { this.getRouteStationsImages(parsedSettings) } else return }

      /* "fG06_Settings": "{\"EngineParameter\": {\"JamState\": false, \"V60State\": true, \"V80State\": true, \"FreeState\": false, \"V100State\": true, \"V120State\": true, \"DangerState\": false}}" */


      this.SelectSettings(parsedSettings)
    }
    else {
      this.getRouteStationsImages()
    }

  }

  public ngOnDestroy(): void {
    this.imageIntervalCollection.forEach(id => clearInterval(id));
  }

  public SelectSettings(settings: any): void {
    if (settings.MQ !== null && settings.MQ !== undefined) {
      this.onVerkehrszustandItemClicked({ id: settings.MQ.VS, name: getVerkehrszustandString(settings.MQ.VS) })
      this.onTrafficItemClicked({ id: settings.MQ.Traffic, name: getVerkehrsstufeString(settings.MQ.Traffic) })
    }
    if (settings.AQ !== null && settings.AQ !== undefined) {
      this.preSelectedImage = this.getImageByStellcode(settings.AQ.Code)
      if (this.preSelectedImage) {
        this.onProjectImageClicked(this.preSelectedImage!)
      }
      if (settings.AQ.Function === 2) {
        this.onFunctionItemClicked({ id: settings.AQ.Function, name: 'Blinkend' });
        this.tlS_Time = settings.AQ.Time
      }
      if (settings.AQ.Function === 1) {
        this.onFunctionItemClicked({ id: settings.AQ.Function, name: 'An' });
      }
      if (settings.AQ.Function === 0) {
        this.onFunctionItemClicked({ id: settings.AQ.Function, name: 'Aus' });
      }
    }
    if (settings.Barrier !== null && settings.Barrier !== undefined) {
      this.onBarrierCommandItemClicked({
        id: settings.Barrier.Command,
        name: getPositioningCmdString(settings.Barrier.Command)
      });
    }

  }

  public getImageByStellcode(stellcode: number) {
    if (!stellcode) return
    if (this.images.length === 0) return
    let image = this.images.find((x) => x.stellcode == stellcode)
    return image

  }

  public getRouteStationsImages(settings?: any) {
    if (settings) {
      if (settings.AQ !== null) {
        this.projectService.getAllRouteStationImagesWithStationId(this.data.projectId, this.data.routeStation.routeStation.id).subscribe(images => {
          this.allImages = images;
          this.images = images;
          this.imagesPW = images.filter(x => x.stellcode > 240)
          this.rotateImagesPaths(images);
          this.preSelectedImage = this.getImageByStellcode(settings.AQ.Code)
          if (this.preSelectedImage) {

            setTimeout(() => {
              this.onProjectImageClicked(this.preSelectedImage!)

            }, 25);
          }
        });
      }
    }
    else {
      this.projectService.getAllRouteStationImagesWithStationId(this.data.projectId, this.data.routeStation.routeStation.id).subscribe(images => {
        this.allImages = images;
        this.images = images;
        this.imagesPW = images.filter(x => x.stellcode > 240)
        this.rotateImagesPaths(images);
      });
    }
  }

  public rotateImagesPaths(images: ProjectImageData[]): void {
    images.forEach(image => {
      if (image.isAnimated && image.animatedImageIds!.length > 0) { /* für jedes Bild, das für die RouteStation gesetzt wird, wird nun separat geprüft ob ein animatedImageId vorhanden ist */
        this.rotatePathForId(image)
      }
    });
  }

  public rotatePathForId(image: ProjectImageData): void {
    const myValueList = image.animatedImageIds!;

    let i = 0;
    const id = setInterval(() => {
      image.path = this.getPathByImageId(myValueList[i++]); /* iteration durchs animatedimage array, und zieht sich dasnn über die id, den path */
      if (i === myValueList.length) {
        i = 0;
      }
    }, 1000);
    this.imageIntervalCollection.push(id);
  }

  public getPathByImageId(imageId: number) {

    if (this.allImages) {
      let imageObject = this.allImages.find((x) => x.imageId == imageId)
      return imageObject?.path as string
    }
    else return
  }

  public onTrafficItemClicked(item: SelectInput): void {
    this.isTrafficDropdownOpen = false;
    this.selectedTraffic.name = item.name
    this.selectedTraffic.id = item.id
  }

  public onVerkehrszustandItemClicked(item: SelectInput): void {
    this.isVerkehrszustandDropdownOpen = false;
    this.selectedVerkehrszustand.name = item.name
    this.selectedVerkehrszustand.id = item.id
  }

  public onVerkehrszustandDropdownClicked() {
    this.isVerkehrszustandDropdownOpen = !this.isVerkehrszustandDropdownOpen;
  }
  public onTrafficDropdownClicked() {
    this.isTrafficDropdownOpen = !this.isTrafficDropdownOpen;
  }
  public onCloseDialogClicked(): void {
    this.dialogRef.close();
  }

  public onDeleConfigClicked(): void {
    this.data.kanal.scenarioControlObj = undefined;
    this.dialogRef.close("deleted");
  }

  public onProjectImageClicked(image: ProjectImageData) {
    if (this.isImageSelected) { this.images = this.allImages; this.isImageSelected = false; return }
    if (this.images) {
      if (this.images.length > 1) {
        this.selectedImage = image
        this.images = [];
        this.images.push(image)
        this.isImageSelected = true;

      }
      else if (this.images.length === 1) {
        this.selectedImage = image
        this.isImageSelected = true;
      }
    }
  }


  public onProjectPWImageClicked(image: ProjectImageData) {
    if (this.imagesPW.length > 1) { this.imagesPW = this.images.filter(x => x.stellcode > 240) }
    if (this.imagesPW) {
      if (this.imagesPW.length > 1) {
        this.selectedImage = image
        this.imagesPW = [];
        this.imagesPW.push(image)
      }
      else if (this.imagesPW.length === 1) {
        this.imagesPW = this.images.filter(x => x.stellcode > 240)
      }
    }
  }

  private getScenarioControlId(): number | undefined {
    const scenarioControlObj = Array.isArray(this.data.kanal.scenarioControlObj)
      ? this.data.kanal.scenarioControlObj[0]
      : undefined;

    return scenarioControlObj?.scenarioControl?.id;
  }

  public onSubmitMQClicked(): void {
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": {\"VS\": ${this.selectedVerkehrszustand.id}, \"Active\": true, \"Traffic\": ${this.selectedTraffic.id}}, \"DO\": null, \"DI\": null, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'MQ',
        scenarioControlId: scenarioControlId,
      })
    }
    else
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": {\"VS\": ${this.selectedVerkehrszustand.id}, \"Active\": true, \"Traffic\": ${this.selectedTraffic.id}}, \"DO\": null, \"DI\": null, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'MQ'
      }) /* Active Bool - Bleibt erstmal TRUE */
  }

  public onSubmitAQClicked(): void {
    this.isImageSelected = false;
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": {\"Active\": true, \"Code\": ${this.selectedImage?.stellcode}, \"Function\": ${this.selectedFunction.id}, \"Time\":${this.tlS_Time} }, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": null}`,
        scenarioControlId: scenarioControlId,
        highPriority: this.highPriority,
        type: 'AQ'
      }) /* Active Bool - Bleibt erstmal TRUE */

    }
    else {
      this.dialogRef.close({
        settings: `{\"AQ\": {\"Active\": true, \"Code\": ${this.selectedImage?.stellcode}, \"Function\": ${this.selectedFunction.id}, \"Time\":${this.tlS_Time} }, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": null}`,

        highPriority: this.highPriority,
        type: 'AQ'
      })
    }
  }


  public onSubmitFlasherClicked(): void {
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": {\"Active\": true, \"Code\": 61, \"Function\": ${this.selectedFunction.id}, \"Time\":${this.tlS_Time} }, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'AQ',
        scenarioControlId: scenarioControlId,
      })
    }
    else {
      this.dialogRef.close({
        settings: `{\"AQ\": {\"Active\": true, \"Code\": 61, \"Function\": ${this.selectedFunction.id}, \"Time\":${this.tlS_Time} }, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'AQ'
      })
    }
  }

  public onSubmitDOClicked(): void {
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": {\"Active\": true, \"State\": ${this.DOstate}}, \"DI\": null, \"Barrier\": null}`, /* TODO: in klärung wie hier die states übermittelt werden sollen */
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'DO',
        scenarioControlId: scenarioControlId,
      })
    }
    else {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": {\"Active\": true, \"State\": ${this.DOstate}}, \"DI\": null, \"Barrier\": null}`, /* TODO: in klärung wie hier die states übermittelt werden sollen */
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'DO'
      })
    }
  }

  public onSubmitDIClicked(): void {
    // Beispiel für DI-Objekt, bitte ggf. anpassen
    const diSettings = `{\"Active\": true, \"State\": ${this.DIstate}}`;
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": null, \"DI\": ${diSettings}, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'DI',
        scenarioControlId: scenarioControlId,
      })
    }
    else {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": null, \"DI\": ${diSettings}, \"Barrier\": null}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'DI'
      })
    }
  }

  public onSubmitBarrierClicked(): void {
    const command = this.selectedBarrierCommand.id;
    const scenarioControlId = this.getScenarioControlId();
    if (scenarioControlId !== undefined) {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": {\"Active\": true, \"Command\": ${command}}}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'Barrier',
        scenarioControlId: scenarioControlId,
      })
    }
    else {
      this.dialogRef.close({
        settings: `{\"AQ\": null, \"MQ\": null, \"DO\": null, \"DI\": null, \"Barrier\": {\"Active\": true, \"Command\": ${command}}}`,
        kanal: this.data.kanal,
        highPriority: this.highPriority,
        type: 'Barrier'
      })
    }
  }

  public isBarrierChannel(kanal: DataEndChannel): boolean {
    return kanal.dataEndChannelType === DataEndChannelTypeEnum.LANESWITCH ||
      kanal.dataEndChannelType === DataEndChannelTypeEnum.BAR ||
      kanal.dataEndChannelType === DataEndChannelTypeEnum.SWING;
  }

  public onBarrierCommandDropdownClicked(): void {
    this.isBarrierCommandDropdownOpen = !this.isBarrierCommandDropdownOpen;
  }

  public onBarrierCommandItemClicked(item: SelectInput): void {
    this.isBarrierCommandDropdownOpen = false;
    this.selectedBarrierCommand.name = item.name;
    this.selectedBarrierCommand.id = item.id;
  }




  public onFunctionItemClicked(item: SelectInput): void {
    this.isFunctionDropdownOpen = false;
    this.selectedFunction.name = item.name
    this.selectedFunction.id = item.id
    if (this.selectedFunction.id !== 2) this.tlS_Time = 0;
  }

  public onPWFunctionItemClicked(item: SelectInput): void {
    this.isPWFunctionDropdownOpen = false;
    this.selectedFunction.name = item.name
    this.selectedFunction.id = item.id

  }

  public onFunctionDropdownClicked(): void {
    this.isFunctionDropdownOpen = !this.isFunctionDropdownOpen;
  }

  public onPWFunctionDropdownClicked(): void {
    this.isPWFunctionDropdownOpen = !this.isPWFunctionDropdownOpen;
  }
}
